import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const communityGardenHarvestObject = z.object({
  id: z.string().uuid(),
  communityGardenId: z.string().uuid(),
  type: z.string().nullish(),
  quantity: z.number().int().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CommunityGardenHarvestType = z.infer<typeof communityGardenHarvestObject>

export const propertyMap = {
  id: sql`community_garden_harvest.id`,
  communityGardenId: sql`community_garden_harvest.community_garden_id`,
  type: sql`community_garden_harvest.type`,
  quantity: sql`community_garden_harvest.quantity`,
  createdAt: sql`community_garden_harvest.created_at`,
  updatedAt: sql`community_garden_harvest.updated_at`,
  deletedAt: sql`community_garden_harvest.deleted_at`,
}

export default communityGardenHarvestObject
